import { styled } from 'styled-components';

export const SliderSection = styled.div`
  margin-bottom: ${({ theme }) => theme.sizing.medium};
  margin-top: ${({ theme }) => theme.sizing.medium};
`;
SliderSection.displayName = 'SliderSection';

export const SliderHeader = styled.div`
  width: 100%;
  position: relative;
  margin-bottom: ${({ theme }) => theme.sizing.small};
  height: 1rem;

  h3 {
    position: absolute;
    top: 6px;
    left: 0;
    color: ${({ theme }) => theme.colours.ink.primary.main};
    ${({ theme }) => theme.typography.headingSmall}
  }

  button {
    float: right;
    margin-left: ${({ theme }) => theme.sizing.small};
  }
`;
SliderHeader.displayName = 'SliderHeader';
